import styles from './order.module.scss';
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Order/Hero";
import { Helmet } from "react-helmet";
import UpButton from '../../components/UpButton';
//======================================
import Form from '../../components/Form'
import { VscFeedback } from "react-icons/vsc";
//== 
import  { useContext ,useEffect } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
//==



function OrderPage({scroll , lang}) {
    const content = `
    We would like to follow-up with you to ensure the maximum knowledge of your opinion about our products and the business co-operation
    possibilities between us. Please take few minutes of your time to fill out the following information.`
    //---
    const { toggleLanguage } = useContext(LanguageContext);
    useEffect(() => {
        toggleLanguage(lang)
    },);
    //---
    return (
    <div>
        <Helmet>
            <title>Millensys - Order</title>
        </Helmet>
        <UpButton scroll={scroll} />
        <div>
            <Header />
            <Hero />
            <section className={`${styles["section__container"]} `}>
                <p className={styles["section__subheader"]}>Order a MILLENSYS Product</p>
                <h2 className={styles["section__header"]}><VscFeedback/> | We appreciate your interests in MILLENSYS products.</h2>
                <p className={styles["__strong"]}>
                {content}
                </p>
                <Form order={true} />
            </section>
            <Footer />
        </div>
    </div>
    )
}

export default OrderPage
